export default __webpack_public_path__ + "static/media/Overpass-Medium.0dbc43f8.woff2";